module.exports = __webpack_public_path__ + "static/img/6.f32c178.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/6.jpg
// module id = eDW1
// module chunks = 1